import React, { type JSX } from 'react';
import { useTranslation } from 'react-i18next';
import type { GroupBase, OptionProps, SingleValueProps } from 'react-select-modern';
import { components as SelectComponents } from 'react-select-modern';

import type { IThirdPartyDataOption } from '@feathr/blackbox';

import * as styles from './AffinityTargetingDataSelect.css';

export function DataOption<
  T extends IThirdPartyDataOption,
  IsMulti extends boolean = boolean,
  Group extends GroupBase<T> = GroupBase<T>,
>(props: Readonly<OptionProps<T, IsMulti, Group>>): JSX.Element {
  const { t } = useTranslation();
  const { data } = props;

  // Render custom content inside react-select's base Option so the focus/
  // selected chrome matches the default (category) select rather than
  // react-select's default inline styles. See Feathr/shrike#8445.
  return (
    <SelectComponents.Option {...props}>
      <div>
        <strong>{data.Name}</strong>
        <span> | </span>
        <span>{t('{{count, number}} Person', { count: data.ActiveIDsCount })}</span>
      </div>
      <div className={styles.path}>
        <p>{data.FullPath}</p>
        <p className={styles.description}>{data.Description}</p>
      </div>
    </SelectComponents.Option>
  );
}

export function DataSingleValue<
  T extends IThirdPartyDataOption,
  IsMulti extends boolean = boolean,
  Group extends GroupBase<T> = GroupBase<T>,
>(props: Readonly<SingleValueProps<T, IsMulti, Group>>): JSX.Element {
  const { t } = useTranslation();
  const { data } = props;

  return (
    <SelectComponents.SingleValue {...props}>
      <div className={styles.single}>
        <strong>{data.Name}</strong>
        <span> | </span>
        <span>{t('{{count, number}} Person', { count: data.ActiveIDsCount })}</span>
      </div>
    </SelectComponents.SingleValue>
  );
}
